export default {
  namespaced: true,
  state: () => ({
    selectedRows: [],
  }),

  getters: {
    getSelectedRows: (state) => state.selectedRows,
  },

  mutations: {
    toggleRow(state, id) {
      if (state.selectedRows.includes(id)) {
        state.selectedRows = state.selectedRows.filter((i) => i !== id);
      } else {
        state.selectedRows.push(id);
      }
    },
    setSelectedAll(state, payload) {
      state.selectedRows = payload;
    },

    clearSelected(state) {
      state.selectedRows = [];
    },
  },
};
